import { useMemo } from 'react';
import { prop } from 'ramda';
import { usePortletSelector } from 'js/components/system/Portlet';
import { LIMIT_FIELD_NAMES } from '../constants';

export const useInitialValues = () => {
    const limits = usePortletSelector(prop('limits'));

    return useMemo(() => ({
        ...Object.values(LIMIT_FIELD_NAMES)
            .reduce((acc, name) => {
                const item = limits[name];

                return {
                    ...acc,
                    [name]: item ? item.limit : 0
                };
            }, {}),
        fetchLimitsTimestamp: Date.now()
    }), [limits]);
};
